import { render, staticRenderFns } from "./Article_releases.vue?vue&type=template&id=2611f140&style=true"
import script from "./Article_releases.vue?vue&type=script&lang=js"
export * from "./Article_releases.vue?vue&type=script&lang=js"
import style0 from "./Article_releases.vue?vue&type=style&index=0&id=2611f140&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports